/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsonlybusinesshint3Inputs */

const en_groupsonlybusinesshint3 = /** @type {(inputs: Groupsonlybusinesshint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members read along and react, but do not write.`)
};

const de_groupsonlybusinesshint3 = /** @type {(inputs: Groupsonlybusinesshint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder lesen mit und reagieren, schreiben aber nichts.`)
};

/**
* | output |
* | --- |
* | "Members read along and react, but do not write." |
*
* @param {Groupsonlybusinesshint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsonlybusinesshint3 = /** @type {((inputs?: Groupsonlybusinesshint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsonlybusinesshint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsonlybusinesshint3(inputs)
	return de_groupsonlybusinesshint3(inputs)
});
export { groupsonlybusinesshint3 as "groupsOnlyBusinessHint" }